import { db } from "../../../config/firebaseconfig";

/**
 * Get all of the students, educators, classes, groupUAs, and userAssessments in the school.
 * @param {string} schoolId id of the school record
 * @returns {object} all of the db records we need to process the upload
 */
export default function initVerification(schoolId) {
  // function init: get all of the students, educators, classes, groupUAs, and userAssessments in the school.
  const keys = ['students', 'educators', 'classes', 'groupUAs', 'userAssessments']
  const getStudents = db.collection('students').where('school', '==', schoolId).get()
  const getEducators = db.collection('educators').where('school', '==', schoolId).get()
  const getClasses = db.collection('classes').where('school', '==', schoolId).get()
  const getGroupUAs = db.collection('groupUA').where('school', '==', schoolId).get()
  const getUserAssessments = db.collection('userAssessments').where('school', '==', schoolId).get()
  return Promise.all([
    getStudents, 
    getEducators, 
    getClasses, 
    getGroupUAs, 
    getUserAssessments
  ])
    .then(results => {
      let output = {}
      results.forEach((result, n) => {
        let obj = {}
        // pulls the data out of each promise return from the db
        result.forEach(doc => {
          if (doc.exists) {
            const data = doc.data()
            let id = data.id || data.userAssessmentId
            obj[id] = data
          }
        })
        // files the data in the master object to the right key
        // (either students, educators, etc.)
        output[keys[n]] = obj
      })
      return output
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/initVerification.js